export enum CoreActionsEnum {
  CORE_SET_LOADING = 'CORE_SET_LOADING',
  CORE_DEEP_SET_LOADING = 'CORE_DEEP_SET_LOADING',
  CORE_SET_LOADING_PROGRESS = 'CORE_SET_LOADING_PROGRESS',
  CORE_SET_ANNOUNCE_HEIGHT = 'CORE_SET_ANNOUNCE_HEIGHT',
  CORE_SET_LAW_INTERFACE = 'CORE_SET_LAW_INTERFACE',
  CORE_SET_PUBLIC_PORTAL_URL = 'CORE_SET_PUBLIC_PORTAL_URL',
  CORE_SET_VISIBLE_CHECK_PLUGIN_MODAL = 'CORE_SET_VISIBLE_CHECK_PLUGIN_MODAL',
  CORE_SET_NOTIFICATION_INFO = 'CORE_SET_NOTIFICATION_INFO',
  CORE_GET_NOTIFICATION_INFO = 'CORE_GET_NOTIFICATION_INFO',
  CORE_REMOVE_FIRST_NOTIFICATION_INFO = 'CORE_REMOVE_FIRST_NOTIFICATION_INFO',
  CORE_GET_OPEN_API_INFO = 'CORE_GET_OPEN_API_INFO',
  CORE_SET_OPEN_API_INFO = 'CORE_SET_OPEN_API_INFO',
  CORE_SET_OPTION_NAME = 'CORE_SET_OPTION_NAME',
}
